import type { PaginatedReviewsResponse, UserReviewListItem, Paginated, GetCommentsResponse } from '@mrb91002/shared-types'

import { API_BASE } from '../config'

export async function fetchAllReviewsForPattern(
  patternId: string,
  limit = 2,
  lastKey: string | null = null,
): Promise<PaginatedReviewsResponse> {
  let url = `${API_BASE}/patterns/${encodeURIComponent(patternId)}/reviews?limit=${limit}`
  if (lastKey) url += `&lastKey=${encodeURIComponent(lastKey)}`
  const resp = await fetch(url)
  if (!resp.ok) throw new Error('Failed to fetch reviews for pattern')
  return resp.json() as Promise<PaginatedReviewsResponse>
}

export async function fetchUserReviews(
  screenName: string,
  limit = 20,
  lastKey: string | null = null,
): Promise<Paginated<UserReviewListItem>> {
  let url = `${API_BASE}/user-reviews/${encodeURIComponent(screenName)}?limit=${limit}`
  if (lastKey) url += `&lastKey=${encodeURIComponent(lastKey)}`
  const resp = await fetch(url)
  if (!resp.ok) throw new Error('Failed to fetch user reviews')
  return resp.json() as Promise<Paginated<UserReviewListItem>>
}

export async function fetchComments(
  entityType: 'pattern' | 'material' | 'project',
  entityId: string,
  includeUserUpvotes: boolean = false,
  idToken?: string,
): Promise<GetCommentsResponse> {
  const entityPath = entityType === 'material' ? 'materials' : entityType === 'project' ? 'craft-projects' : 'patterns'
  const url = `${API_BASE}/${entityPath}/${entityId}/comments${includeUserUpvotes ? '?includeUserUpvotes=true' : ''}`
  const resp = await fetch(url, {
    headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
  })
  if (!resp.ok) throw new Error('Failed to fetch comments')
  return resp.json() as Promise<GetCommentsResponse>
}
